<template lang="pug">
  section-card(title="Export date")
    p Arhiva contine toate documentele institutiei, baza de date si documentatia tehnica. Se poate genera o singura arhiva, care este stearsa dupa descarcare.
    template(v-if="archive")
      template(v-if="archive.status === 'processing'")
        div(class="mb-2") Se genereaza arhiva: {{ archive.processed }} / {{ archive.total }} documente
        v-progress-linear(:value="progress" color="primary" height="20" rounded) {{ progress }}%
      v-alert(v-else-if="archive.status === 'failed'" type="error" dense text class="mb-0") Generarea arhivei a esuat.
      v-alert(v-else type="success" dense text class="mb-0") Arhiva este gata ({{ archive.size }}).
    template(#actions)
      v-btn(v-if="!archive" color="primary" @click="generate") Genereaza arhiva
      template(v-else)
        v-btn(v-if="archive.status === 'failed'" color="primary" @click="generate") Reincearca
        v-btn(v-if="archive.status === 'done'" :href="downloadUrl" color="success") Descarca
        v-spacer
        v-btn(color="red" class="white--text" @click="remove") {{ archive.status === 'processing' ? 'Anuleaza' : 'Sterge arhiva' }}
</template>
<script>
import SectionCard from '@/components/SectionCard';

const POLL_INTERVAL = 3000;

export default {
  components: { SectionCard },
  props: {
    institutionId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      archive: null,
      pollTimeout: null
    };
  },
  computed: {
    progress () {
      return this.archive.total ? Math.floor(this.archive.processed * 100 / this.archive.total) : 0;
    },
    downloadUrl () {
      return `${process.env.VUE_APP_API_URL}/public/exports/${this.archive.token}`;
    }
  },
  mounted () {
    this.loadArchive();
  },
  beforeDestroy () {
    clearTimeout(this.pollTimeout);
  },
  methods: {
    setArchive (res) {
      this.archive = res.data ? res.data.data : null;

      clearTimeout(this.pollTimeout);

      // Keeps following the server: progress while generating, removal once downloaded.
      if (this.archive) {
        this.pollTimeout = setTimeout(this.loadArchive, POLL_INTERVAL);
      }
    },
    loadArchive () {
      return this.axios.get(`/institutions/${this.institutionId}/export`)
        .then(this.setArchive)
        .catch(e => {
          this.$error(e);
        });
    },
    generate () {
      this.$store.commit('pageLoading', true);

      return this.axios.post(`/institutions/${this.institutionId}/export`)
        .then(this.setArchive)
        .catch(e => {
          this.$error(e);
        })
        .finally(() => {
          this.$store.commit('pageLoading', false);
        });
    },
    remove () {
      this.$store.commit('pageLoading', true);

      return this.axios.delete(`/institutions/${this.institutionId}/export`)
        .then(this.setArchive)
        .catch(e => {
          this.$error(e);
        })
        .finally(() => {
          this.$store.commit('pageLoading', false);
        });
    }
  }
};
</script>
